import React from "react";
import { Button } from "@mantine/core";

interface TagFormActionsProps {
  isLoading: boolean;
  buttonText?: string;
}

const TagFormActions: React.FC<TagFormActionsProps> = ({
  isLoading,
  buttonText = "Save",
}) => (
  <Button
    type="submit"
    variant="filled"
    fullWidth
    loading={isLoading}
    loaderPosition="right"
    className="float-right"
    color="jem-theme"
  >
    {buttonText}
  </Button>
);

export default TagFormActions;
